<h3 mat-dialog-title>Ha ocurrido un error</h3>
<div mat-dialog-content>
  <p class="error-message">
    {{ data?.message }}
  </p>
</div>
<div mat-dialog-actions>
</div>
